import React, { useState } from "react";
import PaymentDetails from "./PaymentDetails.js";
import { ChevronDown } from "lucide-react"; // npm install lucide-react
import { FiTag, FiBox } from "react-icons/fi";

const PackageDetails = ({ Address }) => {
  const [products, setProducts] = useState([
    { id: 1, quantity: 1, name: "", sku: "", unitPrice: "" },
  ]);
  const [deadWeight, setDeadWeight] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCommodityId, setSelectedCommodityId] = useState(null);
  const [dimensions, setDimensions] = useState({
    length: "",
    width: "",
    height: "",
  });

  // const REACT_APP_BACKEND_URL=process.env.REACT_APP_BACKEND_URL

  // Handle dimension input changes
  const handleDimensionChange = (e) => {
    const { name, value } = e.target;
    setDimensions((prev) => ({
      ...prev,
      [name]: value.replace(/[^0-9.]/g, ""), // Allow numbers and decimal points only
    }));
  };
  const [showAdditionalFees, setShowAdditionalFees] = useState(false);
  // Function to add a new product
  const addProduct = () => {
    setProducts([
      ...products,
      {
        id: products.length + 1,
        quantity: 1,
        name: "",
        sku: "",
        unitPrice: "",
      },
    ]);
  };

  // Function to remove a product
  const removeProduct = (id) => {
    setProducts(products.filter((product) => product.id !== id));
  };

  // Function to increase quantity
  const increaseQuantity = (id) => {
    setProducts(
      products.map((product) =>
        product.id === id
          ? { ...product, quantity: product.quantity + 1 }
          : product
      )
    );
  };

  // Function to decrease quantity
  const decreaseQuantity = (id) => {
    setProducts(
      products.map((product) =>
        product.id === id && product.quantity > 1
          ? { ...product, quantity: product.quantity - 1 }
          : product
      )
    );
  };

  // Function to handle input changes
  const handleInputChange = (id, field, value) => {
    setProducts(
      products.map((product) =>
        product.id === id ? { ...product, [field]: value } : product
      )
    );
  };
  const calculateVolumetricWeight = () => {
    const { length, width, height } = dimensions;
    return ((length * width * height) / 5000).toFixed(2); // Example formula for volumetric weight
  };

  const volumetricWeight = calculateVolumetricWeight();
  const applicableWeight = Math.max(deadWeight, volumetricWeight, 0.5); // Minimum chargeable weight is 0.5
  // Calculate total price for all products
  const totalPrice = products.reduce((total, product) => {
    const unitPrice = parseFloat(product.unitPrice) || 0; // Ensure unitPrice is a number
    return total + unitPrice * product.quantity;
  }, 0);

  // Combine all data to pass to PaymentDetails
  const packageData = {
    deadWeight,
    dimensions,
    volumetricWeight,
    applicableWeight,
    products,
    address: Address, // Assuming Address is a string or object
    products,
    totalPrice, // Include total price in package data
    // selectedCommodityId,
  };
  console.log(packageData, "thisn i");

  // const selectedOption = commodityOptions.find(
  //   (item) => item.id === selectedCommodityId
  // );

  return (
    <div className="max-w-full mx-auto ">
      <div className="border border-[#632C9D] rounded-lg p-4 bg-white hover:shadow-sm transition-shadow">
        <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-4 text-center md:text-left flex items-center gap-2">
          <span className="bg-[#632C9D] text-white rounded-lg p-2 md:p-2">
            <FiTag className="text-[12px] md:text-[16px]" />
          </span>
          Product Details
        </h2>
        {/* import { ChevronDown } from "lucide-react"; */}

        {products.map((product, index) => (
          <div
            key={product.id}
            className="border border-dashed border-[#632C9D] rounded-lg p-4 mb-6 relative bg-white"
          >
            {/* Index Badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#632C9D] text-white sm:w-8 sm:h-8 w-6 h-6 flex justify-center items-center rounded-full text-[10px] font-[600] shadow">
              {index + 1}
            </div>

            {/* Delete Icon Button */}
            <div className="absolute -top-4 right-4 group">
              <button
                onClick={() => removeProduct(product.id)}
                className="sm:w-8 sm:h-8 w-6 h-6 flex items-center justify-center bg-[#FFE3DC] hover:bg-[#FFD5C9] text-[#F1572C] rounded-full shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M3 6h18v2H3V6zm2 3h14l-1.5 12.5a1 1 0 0 1-1 .5H7a1 1 0 0 1-1-.5L4 9zm5 2v8h2v-8H9zm4 0v8h2v-8h-2z" />
                </svg>
              </button>
              {/* Tooltip */}
              <div className="absolute left-1/2 z-50 -translate-x-1/2 top-full mt-1 px-2 py-1 text-[#F1572C] text-xs rounded shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                Delete
              </div>
            </div>

            {/* Top Row Fields */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div>
                <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                  Product Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter name or search"
                  value={product.name}
                  onChange={(e) =>
                    handleInputChange(product.id, "name", e.target.value)
                  }
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] placeholder:text-[12px] placeholder:font-[400] outline-none focus:ring-1 focus:ring-[#632C9D]"
                />
              </div>
              <div>
                <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                  HSN
                </label>
                <input
                  type="text"
                  placeholder="HSN"
                  value={product.hsn}
                  onChange={(e) =>
                    handleInputChange(product.id, "hsn", e.target.value)
                  }
                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] placeholder:text-[12px] placeholder:font-[400] outline-none focus:ring-1 focus:ring-[#632C9D]"
                />
              </div>
              <div>
                <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                  Quantity <span className="text-red-500">*</span>
                </label>
                <div className="flex items-center border border-gray-300 rounded-md overflow-hidden">
                  <button
                    onClick={() => decreaseQuantity(product.id)}
                    className="px-3 py-2 bg-gray-100 text-sm font-medium hover:bg-gray-200"
                  >
                    -
                  </button>
                  <input
                    type="text"
                    readOnly
                    value={product.quantity}
                    className="w-full text-center px-3 py-2 text-[12px] outline-none"
                  />
                  <button
                    onClick={() => increaseQuantity(product.id)}
                    className="px-3 py-2 bg-gray-100 text-sm font-medium hover:bg-gray-200"
                  >
                    +
                  </button>
                </div>
              </div>
              <div>
                <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                  Unit Price <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-2.5 text-[12px] font-[400] text-gray-500">
                    ₹
                  </span>
                  <input
                    type="text"
                    placeholder="Unit Price"
                    value={product.unitPrice}
                    onChange={(e) =>
                      handleInputChange(product.id, "unitPrice", e.target.value)
                    }
                    className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                  />
                </div>
              </div>
            </div>

            {/* Toggle Optional Fields */}
            <div
              className="mt-4 flex items-center space-x-1 cursor-pointer text-sm"
              onClick={() => setShowAdditionalFees(!showAdditionalFees)}
            >
              <span className="text-[#632C9D] hover:underline hover:text-purple-500 text-[12px] font-[600]">
                + Add Category, SKU, Discount and Tax
              </span>
              <span className="text-xs text-gray-500">(optional)</span>
            </div>

            {/* Optional Fields */}
            {showAdditionalFees && (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                <div>
                  <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                    Product Category
                  </label>
                  <input
                    type="text"
                    placeholder="Product Category"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                  />
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                    SKU
                  </label>
                  <input
                    type="text"
                    placeholder="Enter SKU"
                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                  />
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                    Discount
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-2.5 text-[12px] text-gray-500">
                      ₹
                    </span>
                    <input
                      type="number"
                      placeholder="Discount"
                      className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                    />
                  </div>
                </div>
                <div>
                  <label className="font-[600] text-[12px] text-gray-700 mb-1 block">
                    Tax
                  </label>
                  <div className="relative">
                    <span className="absolute left-3 top-2.5 text-[12px] text-gray-500">
                      ₹
                    </span>
                    <input
                      type="number"
                      placeholder="Tax"
                      className="w-full pl-6 border border-gray-300 rounded-md px-3 py-2 text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Add Product Button */}
        <button
          onClick={addProduct}
          className="flex items-center justify-center sm:w-8 sm:h-8 w-6 h-6 bg-[#632C9D] text-white rounded-full mx-auto text-[12px] sm:text-[14px] hover:bg-[#099f69]"
        >
          +
        </button>
      </div>

      {/* Package Details */}

      <div className="border mt-4 border-[#632C9D] rounded-lg p-4 bg-white hover:shadow-sm transition-shadow">
        <h2 className="text-[12px] md:text-[16px] font-[600] text-gray-700 mb-2 text-center md:text-left flex items-center gap-2">
          <span className="bg-[#632C9D] text-white rounded-lg p-2 md:p-2">
            <FiBox className="text-[12px] md:text-[16px]" />
          </span>
          Package Details
        </h2>

        {/* Inputs in One Line */}
        <div className="flex sm:flex-row flex-col items-start gap-4 bg-white rounded-lg w-full">
          {/* Dead Weight */}
          <div className="w-[160px] flex flex-col">
            <label className="font-[600] sm:text-[12px] text-[10px] text-gray-700 mb-1">
              Dead Weight:
            </label>
            <div className="flex items-center border rounded-md w-full">
              <input
                type="text"
                value={deadWeight}
                onChange={(e) =>
                  setDeadWeight(e.target.value.replace(/[^0-9.]/g, ""))
                }
                className="w-full h-8 px-2 sm:text-[12px] text-[10px] border-none outline-none rounded-l-md"
                placeholder="0.00"
              />
              <span className="w-12 h-8 flex justify-center items-center sm:text-[12px] text-[10px] text-white rounded-r-md bg-[#632C9D]">
                kg
              </span>
            </div>
          </div>

          {/* Dimensions */}
          <div className="flex flex-row gap-2 w-full">
            {["length", "width", "height"].map((dim) => (
              <div key={dim} className="w-full md:w-[160px] flex flex-col">
                <label className="font-[600] sm:text-[12px] text-[10px] text-gray-700 mb-1 capitalize">
                  {dim}:
                </label>
                <div className="flex items-center border rounded-md w-full">
                  <input
                    type="text"
                    name={dim}
                    value={dimensions[dim]}
                    onChange={handleDimensionChange}
                    placeholder={dim.charAt(0).toUpperCase() + dim.slice(1)}
                    className="w-full h-8 px-2 text-[12px] border-none outline-none rounded-l-md"
                  />
                  <span className="w-12 h-8 flex justify-center items-center text-[10px] sm:text-[12px] text-white rounded-r-md bg-[#632C9D]">
                    cm
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Note Section */}
        <p className="text-[12px] font-[400] text-gray-500 mt-2">
          <span className="text-red-500"> Note: </span>Note: The minimum
          chargeable weight is <strong>0.50 Kg</strong>. Dimensions should be in{" "}
          <strong>centimeters only</strong> and values should be greater than{" "}
          <strong>0.50 cm</strong>.
        </p>

        {/* Results */}
        <div className="flex flex-col sm:flex-row gap-4 bg-white rounded-lg mt-2">
          <div className="bg-purple-100 shadow-sm rounded-lg p-4 w-full sm:w-2/4">
            <div className="flex flex-row sm:flex-col justify-between sm:justify-normal">
              <h3 className="text-[12px] font-[600] text-gray-700">
                Applicable Weight
              </h3>
              <p className="text-[12px] font-[600] text-gray-700">
                {applicableWeight} Kg
              </p>
            </div>
            <p className="text-[12px] font-[400] text-gray-500 mt-2">
              Applicable weight is the heavier among Dead Weight vs Volumetric
              Weight.
            </p>
            <p className="text-[12px] font-[400] text-gray-500 mt-2">
              Final chargeable weight will be based on the weight slab of the
              courier selected.
            </p>
          </div>
          <div className="bg-purple-100 shadow-sm rounded-lg px-4 py-2 w-full flex sm:flex-col justify-between sm:justify-normal flex-row sm:w-1/2">
            <h3 className="text-[12px] font-[600] text-gray-700">
              Volumetric Weight
            </h3>
            <p className="text-[12px] font-[600] text-gray-700">
              {volumetricWeight} Kg
            </p>
          </div>
        </div>

        <hr className="my-4 border-t border-gray-300" />

        {/* Display Total Price */}
        <div className="bg-purple-100 px-4 py-2 rounded-lg mb-4 flex flex-row justify-between items-center">
          <p className="text-gray-700 text-[12px] lg:text-[12px] sm:text-[12px] font-[600]">
            Total Order Value
          </p>
          <p className="text-[12px] font-[600] text-gray-700">₹{totalPrice}</p>
        </div>
      </div>
      <div>
        {/* Payment Details */}
        <PaymentDetails packageData={packageData} />
      </div>
    </div>
  );
};

export default PackageDetails;
